export const firstIdeaCopy = {
  en: {
    yourTopic: 'Your topic',
    contextChoice: 'What is this video for?',
    forLabel: 'For:',
    change: 'Change',
    forBusiness: 'My business',
    different: 'A different topic',
    separate: 'A separate project. Your Business Profile stays unchanged.',
    topic: 'What should this content be about?',
    audience: 'Who is it for? (optional)',
    topicBasis: 'Based on your topic',
    topicFinding: 'Finding ideas for your topic',
    topicFit: 'Why it fits your topic',
    scriptLoading: 'Loading your saved script…',
    objective: 'Purpose',
    loading: 'Loading your saved business…',
    entryUnavailable:
      'We couldn’t load your next step. Reload to try again; nothing has started.',
    business: 'Your business',
    idea: 'Your idea',
    script: 'Your script',
    confirm: 'Here’s what we understood',
    returning: 'Your next video starts here',
    details: 'Review details',
    find: 'Find ideas for me',
    develop: 'Develop my idea',
    confirmFind: 'Looks right—find ideas for me',
    confirmDevelop: 'Looks right—develop my idea',
    own: 'I have an idea',
    startWith: 'How would you like to start?',
    seed: 'What do you have in mind?',
    seedHint: 'A rough sentence is enough. We’ll help develop it.',
    language: 'Content language',
    more: 'More options',
    instructions: 'Instructions (optional)',
    added: 'Instructions added',
    focus: 'A topic to explore (optional)',
    next: 'Next: choose an idea, then prepare its script.',
    nextOwn: 'Next: review your developed idea, then prepare its script.',
    starting: 'Starting research…',
    startFailed:
      'Your inputs are kept. Retry this saved start to check whether it completed.',
    retry: 'Retry saved start',
    invalid: 'Check your idea and field lengths.',
    missing: 'Complete the missing business details first.',
    edit: 'Edit details',
    finding: 'Finding ideas for your business',
    developing: 'Developing your idea',
    searching: 'Looking for relevant examples',
    shaping: 'Shaping your ideas',
    safe: 'You can leave this page. Your progress is saved.',
    three: 'Three ideas for your next video',
    partial: 'Ideas for your next video',
    one: 'Your idea, developed',
    original: 'Your starting idea',
    opening: 'The opening',
    fit: 'Why it fits',
    inspiration: 'See the inspiration',
    extra: 'More about this idea',
    adjust: 'Adjust this idea',
    adjustField: 'What would you like to change?',
    adjustHint: 'For example: make it more beginner-friendly.',
    update: 'Update idea',
    adjustCost:
      'Reuses this research. Model usage may apply; no new reference searches.',
    adjusting: 'Updating your idea…',
    adjustFailed:
      'Your previous idea and requested changes are saved. You can retry the adjustment.',
    use: 'Use this idea',
    selecting: 'Saving idea…',
    selected: 'Your idea is selected',
    prepare: 'Prepare script',
    noVideo: 'Next: prepare its script. No video is generated yet.',
    businessBasis: 'Based on your business',
    savedBasis: 'Saved inspiration',
    liveBasis: 'Research-backed inspiration',
    noEvidence: 'No external reference supports this idea yet.',
    reconnect: 'Could not refresh. Your last saved work is shown.',
    reload: 'Reload saved state',
    history: 'Idea history',
    historical: 'Previous idea revision — read only',
    latest: 'View latest version',
    current: 'Current',
    failed: 'Research needs attention. Your input is saved.',
    unavailable:
      'We couldn’t develop this idea in the chosen language. Your original input is saved.',
    retained: 'Your original idea is kept as a draft; it has not been fully developed.',
    newAttempt: 'Start with a revised brief',
    changeFailed:
      'Could not complete the action. Your input is kept. Reload the saved state before trying again.',
    close: 'Close',
    cancel: 'Cancel',
    profileApproved: 'Approved business',
    lines: 'My projects',
    back: 'Back to ideas',
    production:
      'Script approved. Video production comes next; it is not configured here. No video was generated.',
  },
  ar: {
    yourTopic: 'موضوعك',
    contextChoice: 'لأي غرض هذا الفيديو؟',
    forLabel: 'لـ:',
    change: 'تغيير',
    forBusiness: 'نشاطي',
    different: 'موضوع مختلف',
    separate: 'مشروع مستقل. لن يتغيّر ملف نشاطك.',
    topic: 'ما موضوع هذا المحتوى؟',
    audience: 'لمن هذا المحتوى؟ (اختياري)',
    topicBasis: 'مبنية على موضوعك',
    topicFinding: 'نبحث عن أفكار تناسب موضوعك',
    topicFit: 'لماذا تناسب موضوعك',
    scriptLoading: 'جارٍ تحميل النص المحفوظ…',
    objective: 'الهدف',
    loading: 'جارٍ تحميل نشاطك المحفوظ…',
    entryUnavailable:
      'تعذّر تحميل خطوتك القادمة. أعد التحميل للمحاولة؛ لم تبدأ أي عملية.',
    business: 'نشاطك',
    idea: 'فكرتك',
    script: 'نصك',
    confirm: 'هذا ما فهمناه عن نشاطك',
    returning: 'فيديوك القادم يبدأ هنا',
    details: 'راجع التفاصيل',
    find: 'اقترح لي أفكاراً',
    develop: 'طوّر فكرتي',
    confirmFind: 'صحيح، اقترح لي أفكاراً',
    confirmDevelop: 'صحيح، طوّر فكرتي',
    own: 'لدي فكرة',
    startWith: 'كيف تود أن تبدأ؟',
    seed: 'ما فكرتك؟',
    seedHint: 'تكفي جملة بسيطة. سنساعدك على تطويرها.',
    language: 'لغة المحتوى',
    more: 'خيارات إضافية',
    instructions: 'تعليمات إضافية (اختياري)',
    added: 'تمت إضافة تعليمات',
    focus: 'موضوع للبحث (اختياري)',
    next: 'التالي: اختر فكرة، ثم أعدّ نصها.',
    nextOwn: 'التالي: راجع فكرتك بعد تطويرها، ثم أعدّ نصها.',
    starting: 'جارٍ بدء البحث…',
    startFailed: 'احتفظنا بمدخلاتك. أعد محاولة البدء المحفوظة للتحقق من اكتمالها.',
    retry: 'إعادة محاولة البدء المحفوظة',
    invalid: 'راجع الفكرة وطول الحقول.',
    missing: 'أكمل تفاصيل النشاط الناقصة أولاً.',
    edit: 'تعديل التفاصيل',
    finding: 'نبحث عن أفكار تناسب نشاطك',
    developing: 'نطوّر فكرتك',
    searching: 'نبحث عن أمثلة ذات صلة',
    shaping: 'نصيغ أفكارك',
    safe: 'يمكنك مغادرة الصفحة. تقدمك محفوظ.',
    three: 'ثلاث أفكار للفيديو القادم',
    partial: 'أفكار للفيديو القادم',
    one: 'فكرتك بعد تطويرها',
    original: 'فكرتك الأصلية',
    opening: 'البداية',
    fit: 'لماذا تناسبك',
    inspiration: 'شاهد مصادر الإلهام',
    extra: 'المزيد عن هذه الفكرة',
    adjust: 'عدّل هذه الفكرة',
    adjustField: 'ما الذي تريد تغييره؟',
    adjustHint: 'مثلاً: اجعلها أبسط للمبتدئين.',
    update: 'حدّث الفكرة',
    adjustCost:
      'نستخدم البحث المحفوظ. قد تُحتسب تكلفة استخدام النموذج، دون بحث جديد عن مراجع.',
    adjusting: 'جارٍ تحديث فكرتك…',
    adjustFailed:
      'احتفظنا بفكرتك السابقة والتعديل المطلوب. يمكنك إعادة محاولة التعديل.',
    use: 'اعتمد هذه الفكرة',
    selecting: 'جارٍ حفظ الفكرة…',
    selected: 'تم اعتماد فكرتك',
    prepare: 'أعدّ النص',
    noVideo: 'التالي: إعداد النص. لن يُنتج فيديو الآن.',
    businessBasis: 'مبنية على نشاطك',
    savedBasis: 'مصدر إلهام محفوظ',
    liveBasis: 'مستوحاة من البحث',
    noEvidence: 'لا تدعم هذه الفكرة مراجع خارجية حتى الآن.',
    reconnect: 'تعذّر التحديث. نعرض آخر حالة محفوظة لعملك.',
    reload: 'إعادة تحميل الحالة المحفوظة',
    history: 'سجل الأفكار',
    historical: 'إصدار سابق للفكرة — للقراءة فقط',
    latest: 'اعرض أحدث إصدار',
    current: 'الحالي',
    failed: 'البحث يحتاج إلى متابعة. مدخلاتك محفوظة.',
    unavailable: 'تعذّر تطوير الفكرة باللغة المختارة. فكرتك الأصلية محفوظة.',
    retained: 'احتفظنا بفكرتك الأصلية كمسودة؛ لم تُطوّر بالكامل بعد.',
    newAttempt: 'ابدأ بملخص معدّل',
    changeFailed:
      'تعذّر إكمال الإجراء. مدخلاتك محفوظة. أعد تحميل الحالة المحفوظة قبل المحاولة مجدداً.',
    close: 'إغلاق',
    cancel: 'إلغاء',
    profileApproved: 'نشاط معتمد',
    lines: 'مشاريعي',
    back: 'العودة إلى الأفكار',
    production:
      'تم اعتماد النص. إنتاج الفيديو هو المرحلة التالية، لكنه غير مهيّأ هنا. لم يتم إنتاج فيديو.',
  },
} as const;
